import React from "react";
import { Grid } from "@mui/material";
import {
  AddItemButton,
  ArrayInput,
  Button,
  NumberInput,
  SelectInput,
  SimpleForm,
  SimpleFormIterator,
  useSimpleFormIteratorItem,
} from "react-admin";
import { settings } from "app";
import ProfessorInput from "server/components/Fields/ProfessorInput";
import { ExamCommissionRoles } from "utils/choices";
import CloseIcon from "@mui/icons-material/Close";
import SaveButtonProfessors from "./SaveButtonProfessors";
import { groupByCommission } from "components/AcademicYears/helpers";

const SessionExamProfessorEditForm = ({ record, setIsProfessorEditing }) => {
  const IndexField = () => {
    const { index } = useSimpleFormIteratorItem();
    return (
      <Grid
        item
        xs={12}
        md={2}
      >
        <NumberInput
          readOnly
          source="commissionNumber"
          label="Комисия #"
          defaultValue={index + 1}
        />
      </Grid>
    );
  };

  const professors = record?.professors ?? [];

  const commissions = groupByCommission(professors);
  return (
    <Grid
      item
      xs={12}
    >
      <SimpleForm
        toolbar={false}
        sx={{ pt: 0, pl: 0 }}
      >
        <Grid
          container
          spacing={2}
        >
          <ArrayInput
            source="commissions"
            label=" "
            defaultValue={commissions}
          >
            <SimpleFormIterator
              disableReordering
              disableClear
              addButton={<AddItemButton label="Добави комисия" />}
              inline={false}
              sx={settings.style.iteratorWithoutGap}
            >
              <IndexField />
              <ArrayInput
                source="professors"
                label=" "
                defaultValue={[]}
                sx={{ ml: 2 }}
              >
                <SimpleFormIterator
                  disableReordering
                  disableClear
                  addButton={<AddItemButton label="Добави преподавател" />}
                  inline
                  sx={settings.style.iteratorWithoutGap}
                >
                  <ProfessorInput
                    source="professorEmployeeId"
                    fullWidth
                    filters={{ disciplineId: record?.disciplineId }}
                  />
                  <SelectInput
                    source="role"
                    label="Роля"
                    choices={ExamCommissionRoles}
                    optionValue="id"
                    optionText="name"
                  />
                </SimpleFormIterator>
              </ArrayInput>
            </SimpleFormIterator>
          </ArrayInput>
        </Grid>
        <Grid sx={{ display: "flex", gap: 3, ml: 2 }}>
          <Button
            variant="outlined"
            startIcon={<CloseIcon />}
            color="error"
            size="small"
            label="Откажи"
            onClick={() => setIsProfessorEditing(false)}
          />
          <SaveButtonProfessors
            record={record}
            setIsProfessorEditing={setIsProfessorEditing}
          />
        </Grid>
      </SimpleForm>
    </Grid>
  );
};

export default SessionExamProfessorEditForm;
